import { Time } from "@angular/common";

export class BookAppointment {
  PatientName: string;
  PatientMobile?: any;
  PatientGender?: string ="";
  PatientDOB: string;
  PatientAge: string;
  PatientEmail: string;
  AppointmentID: number;
  IsTeleMedicineSlot: boolean;
  IsTeleMedicineTermsAndConditions: boolean;
  BookingTypeId: number;
  AppointmentPatientTypeId: number = 1;
  ParentAppointmentId: number;
  RootAppointmentId: number;
  AppointmentStatus: string;
  StartTime: string;
  EndTime: string;
  DoctorID: number;
  DayCD: string;
  VisitUserTypeID: string;
  ConsultationDt: string;
  UserBranchId: number;
  PatientID: number;
  MasterPatientId: number;
  UserId: number;
  USRType: string; 
  DoctorVisitRsnID: string;
  HospitalDetails: HospitalDetails;
  ReferralSourceDtls: ReferralSourceDtls;
  searchDoctorsObj: searchDoctorsObj;
  CommunicationDetails: CommunicationDetails;
  Productinfo: any;
  PreviousAppointmentDate: string;
  IsFollowUp: boolean;
  SendDocSms: boolean;
  SendDocEmail: boolean;
  SendPatientEmail: boolean;
  SendPatientSms: boolean;
  PatientTypeId: number;
  PatientTitle: string;
  PaidFollowup: boolean;
  FirstName: string;
  LastName: string;
  masterQuestions: any;
  consultationFee: number;
  additionalCharges: number;
  totalAmount: number;
  consultationType: string;
  avgconsultationTime: number;
  hash: string;
  txnid: string;
  ProductType: string;
  Amount: number;
  TransactionId: number;
  udf1: string;
  udf2: string;
  udf3: string;
  udf4: string;
  udf5: string;
  zipcode: number;
  city: string;
  RedirectUrl: string;
  Problem: string;
  PromoCodeId: number;
  PromoCodeAmount: number;
  PromoCode: string;
  SubSpecializationId: number;
  BranchSubSpecializationId: number;
}

export class Productinfo {
  name: string;
  merchantId: string;
  value: number;
  commission: number;
  description: string;
}

export class LeadObject {
  PatientName: string;
  PatientEmail: string;
  PatientMobile: string;
  PatientId: number;
  HospitalId: number;
  AppointmentDate: string;
  Problem: string;
}

export class CommunicationDetails {
  PatientName: string;
  PatientMobile: string;
  DoctorMobile: string;
  DoctorName: string;
  AppDate: string;
  AppTime: string;
  AppToken: number;
  BranchEmail: string;
  DoctorEmail: string;
  HospitalContact: number;
  PatientEmail: string;
  BrnachAddress: BrnachAddress;
  CommunicationEmailId: string;
  CommunicationMobileNo: string;
}

export class BrnachAddress {
  Address1: string;
  Address2: string;
  Location?: any;
  StateId?: any;
  PinCode: string;
  CountryId?: any;
  CityId: number;
  DistrictRegion: number;
  Latitude: string;
  Longitude: string;
}

export class ReferralSourceDtls {
  ReferralID: number;
  SubReferralID: number;
}

export class searchDoctorsObj {
  CityObj: any;
  BranchObj: any;
  CityId: number;
  BranchId: number;
  SubSpecializationId: number;
  AllSubSpecializationInd: number;
}

export class HospitalDetails {
  HospitalID: number;
  ParentHospitalID: number;
  LoginHospitalID: number;
  SenderId: string;
  IsSMSInd: boolean;
}

export class PaymentConfirmationObj {
  key: string;
  txnid: string;
  hash: string;
  amount: number;
  firstname: string;
  email: string;
  phone: number;
  hospitalname: string;
  hospitalid: number;
  hospitalarea: string;
  doctorname: string;
  doctormobile: number;
  doctoremail: string;
  appointmentdate: Date;
  appointmenttime: number;
  slotTime: string;
  consultationFee: number;
  additionalCharges: number;
  IsTeleMedicineSlot: boolean;
  totalCost: number;
  productinfo: string;
  service_provider: string;
  surl: string;
  furl: string;
  udf1: string;
  udf2: string;
  udf3: string;
  udf4: string;
  udf5: string;
  zipcode: number;
  city: string;
  parentHospitalId: number;
  address1: string;
  address2: string;
  state: string;
  country: string;
  CommunicationMobileNo: number;
  CommunicationEmailId: string;
}




// WEBPACK FOOTER //
// ./src/app/Class/BookAppointment.ts